/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { find } from "lodash";
import {
  InputField,
  InputNumberField,
  LocationSelectedField,
} from "../../molecules";
import { ModalWrapper } from "../../../common/modals/ModalWrapper";
import { IYachtInput } from "../../../common/types";
import { Alert, Button, Divider, Form, InputFormWrapper } from "../../atoms";
import { addYachtToFirestore } from "../../../firestore/firestoreService";
import { closeModal } from "../../../redux/data/modals/modalReducer";

export const AddYachtModal: React.FC = (props) => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const { locations } = useSelector((state: any) => state.locations);
  const [error, setError] = React.useState("");

  const handleSubmit = async () => {
    try {
      const values: IYachtInput = await form.validateFields();
      const location = find(locations, ["id", values.locationId]);
      setLoading(true);
      const yacht = await addYachtToFirestore({
        name: values.name,
        locationName: location.name,
        locationId: values.locationId || "",
        maxCapacity: values.maxCapacity,
        status: true,
      });
      setLoading(false);
      dispatch(closeModal());
      history(`/setting/yacht/${yacht.id}`);
    } catch (errorInfo) {
      setLoading(false);
      if (typeof errorInfo === "string") {
        setError(errorInfo.toUpperCase());
      } else if (errorInfo instanceof Error) {
        setError(errorInfo.message);
      }
    }
  };
  return (
    <ModalWrapper {...props} footer={null}>
      {error !== "" && (
        <Alert message={error} type="error" style={{ marginBottom: 20 }} />
      )}
      <InputFormWrapper>
        <div className="input-form-body">
          <Form
            form={form}
            name="horizontal_login"
            layout="vertical"
            autoComplete="off"
          >
            <InputField
              label="Yacht Name"
              name="name"
              rules={[{ required: true, message: "Missing Yacht Name" }]}
              placeholder="Yacht Name"
              style={{ width: "100%" }}
            />
            <LocationSelectedField
              label="Location"
              name="locationId"
              rules={[{ required: true, message: "Missing Type" }]}
            />
            <InputNumberField
              label="Max Capacity"
              name="maxCapacity"
              min={0}
              placeholder="Max Capacity"
              style={{ width: "100%" }}
              rules={[{ required: true, message: "Missing Max Capacity" }]}
            />

            <Divider></Divider>
            <Button
              type="primary"
              className="input-form-btn"
              onClick={handleSubmit}
              loading={loading}
            >
              Add Yacht
            </Button>
          </Form>
        </div>
      </InputFormWrapper>
    </ModalWrapper>
  );
};
